import type { DataLayerEvent } from './types'

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

export function pushToDataLayer(event: DataLayerEvent) {
  if (typeof window === 'undefined') {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'Interaction', ...event })
}
